"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.DAYS_OF_WEEK = void 0;
exports.default = WeekDayFilter;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("@kyruus/button"));
var _styles = require("./styles");
const DAYS_OF_WEEK = exports.DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
function WeekDayFilter(_ref) {
  let {
    filterBy,
    onChange
  } = _ref;
  const handleClick = (index, day) => {
    const nextDayOfWeek = new _set.default(filterBy.dayOfWeek);
    if (nextDayOfWeek.has(index)) {
      nextDayOfWeek.delete(index);
    } else {
      nextDayOfWeek.add(index);
    }
    onChange(nextDayOfWeek, day);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "WeekDayFilter"
  }, (0, _map.default)(DAYS_OF_WEEK).call(DAYS_OF_WEEK, (day, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: day
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": day,
    title: day,
    mode: filterBy.dayOfWeek.has(index) ? 'primary' : 'secondary',
    onClick: () => handleClick(index, day)
  }, day.charAt(0)))));
}
WeekDayFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WeekDayFilter"
};